import { render, staticRenderFns } from "./APIDoc.vue?vue&type=template&id=dbd743ee&scoped=true"
import script from "./APIDoc.vue?vue&type=script&lang=js"
export * from "./APIDoc.vue?vue&type=script&lang=js"
import style0 from "./APIDoc.vue?vue&type=style&index=0&id=dbd743ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd743ee",
  null
  
)

export default component.exports